import { useQuery } from "@tanstack/react-query";
import { AIAgentModelProvider } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import { toProviderAuth } from "aiagent/providerAuth";
const EMPTY_CONFIG = { providers: [], default_provider: null, default_model_id: null };
const toCredentialsJson = (credentials) => ({
  provider: credentials.provider,
  auth: toProviderAuth(credentials.auth)
});
const toConfigJson = (config) => ({
  providers: config.providers.map(toCredentialsJson),
  default_provider: config.default_provider,
  default_model_id: config.default_model_id
});
const useModelProviderConfig = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["ai-model-provider-config"],
    queryFn: () => defaultOnError(
      AIAgentModelProvider.getConfig().then(toConfigJson),
      "Loading model provider configuration failed",
      "Could not load model provider configuration"
    )
  });
  return { data: data != null ? data : EMPTY_CONFIG, isLoading, refetch };
};
export default useModelProviderConfig;
